<template>
  <div class="btn-agreement-container" @click="changeState">
    <div class="btn-agreement-checkbox">
      <line-block
          :icon="'line-violet'"
          :class="{'is-not-active': !isActive}"/>
    </div>
    <div class="main-paragraph-container">
      {{ text }}
    </div>
  </div>
</template>

<script>
import LineBlock from "@/components/shared/LineBlock.vue";

export default {
  name: "ButtonAgreement",
  components: {LineBlock},
  data() {
    return {
      isActive: false,
      text: 'Ознакомлен(а) с Политикой в области обработки\n' +
          'персональных данных и даю согласие на их обработку'
    }
  },
  methods: {
    changeState() {
      this.isActive = !this.isActive
      this.$emit('changeStateAgreementButton')
    }
  }
}
</script>

<style scoped lang="scss">
  .btn-agreement-container {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all .3s ease;

    &:hover {
      opacity: .8;
    }


    .btn-agreement-checkbox {
      width: 0;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(var(--color-light-purple-grey-rgba), .1);
    }
    .line-block-container {
      transition: all .3s ease;
      &.is-not-active {
        min-width: 0;
      }
    }

    .main-paragraph-container {
      font-family: 'Verdana', sans-serif;
      white-space: pre-wrap;
      color: var(--color-light-grey);
    }
  }

  @media (max-width: 3024px){
    .btn-agreement-container {
      column-gap: 48px;
      .btn-agreement-checkbox {
        min-width: 66px;
        height: 66px;
        border-radius: 16px;
      }

      .main-paragraph-container {
        font-size: 22px;
      }
    }
  }

  @media (max-width: 1920px) {
    .btn-agreement-container {
      column-gap: 32px;

      .btn-agreement-checkbox {
        min-width: 66px;
        height: 66px;
        border-radius: 16px;
      }

      .main-paragraph-container {
        font-size: 18px;
      }
    }
  }
  @media (max-width: 1600px) {
    .btn-agreement-container {
      column-gap: 24px;

      .btn-agreement-checkbox {
        min-width: 42px;
        height: 42px;
        border-radius: 10px;
      }

      .main-paragraph-container {
        font-size: 14px;
      }
    }
  }
  @media (max-height: 800px) {
    .btn-agreement-container {
      column-gap: 16px;

      .btn-agreement-checkbox {
        min-width: 34px;
        height: 34px;
        border-radius: 8px;
      }

      .main-paragraph-container {
        font-size: 12px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .btn-agreement-container {
      column-gap: 24px;

      .btn-agreement-checkbox {
        min-width: 42px;
        height: 42px;
        border-radius: 10px;
      }

      .main-paragraph-container {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 1133px) {
    .btn-agreement-container {
      column-gap: 16px;

      .btn-agreement-checkbox {
        min-width: 34px;
        height: 34px;
        border-radius: 8px;
      }

      .main-paragraph-container {
        font-size: 12px;
      }
    }
  }

  @media (max-width: 769px) {
    .btn-agreement-container {
      .main-paragraph-container {
        white-space: normal;
      }
    }
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .btn-agreement-container {
      column-gap: 60px;
      .btn-agreement-checkbox {
        min-width: 96px;
        height: 96px;
        border-radius: 24px;
      }

      .main-paragraph-container {
        font-size: 28px;
      }
    }
  }

</style>